// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Hero section
   - Exactly 100dvh, no overflow
   - Background image fades to cream on left
   - Left index rail: small icons, long connector line
   ============================================================ */

.hero {
  position: relative;
  /* Exactly one viewport height — no overflow */
  height: 100dvh;
  background: var(--c-cream);
  overflow: hidden;
  isolation: isolate;
}

/* ---- Background media ---- */
.hero__media {
  position: absolute;
  inset: 0;
  mix-blend-mode: multiply;
  z-index: -1;
}

.hero__img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 0% center;
}

/* Cream scrim fades image → legible headline on left */
.hero__scrim {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 26%, rgba(244, 239, 230, 0.78) 40%, rgba(244, 239, 230, 0.18) 60%, rgba(244, 239, 230, 0) 76%),
    linear-gradient(to top, rgba(27, 27, 27, 0.22) 0%, rgba(27, 27, 27, 0) 36%);
}

/* ---- Layout shell ---- */
.hero__inner {
  position: relative;
  /* Fill exactly the viewport; navbar is fixed so no offset needed */
  height: 100dvh;
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center; /* vertically center the rail + content */
  column-gap: clamp(1rem, 2.5vw, 2.25rem);
  padding-top: 64px; /* clear the fixed navbar */
  z-index: 3;
}

/* ---- Index rail ---- */
.hero__rail {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0; /* gaps managed per-child */
  color: var(--c-ink);
  height: 100%;
  justify-content: center;
}

.hero__rail-num {
  font-family: var(--font-body);
  font-size: 1.5rem;
  font-weight: 500;
  letter-spacing: 0.1em;
  margin-bottom: 0.9rem;
}

/* Long connector line — matches the screenshot proportion */
.hero__rail-line {
  width: 1px;
  /* tall line, icons sit below it */
  height: clamp(3.5rem, 10vw, 7rem);
  background: rgba(27, 27, 27, 0.3);
  margin-bottom: 0.9rem;
}
.hero__rail-line.alt {
  width: 1px;
  /* tall line, icons sit below it */
  height: clamp(1.5rem, 2.5vw, 3rem);
  background: rgba(27, 27, 27, 0.3);
  margin-bottom: 0.3rem;
  margin-top: 0.3em;
}

/* Icons — small, evenly spaced, separated by short tick lines */
.hero__rail-icons {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.hero__rail-icons li {
  display: grid;
  place-items: center;

  font-size: 2rem;
  color: var(--c-ink);
  opacity: 0.8;
  padding: 0.65rem 0;
  position: relative;
}

/* Thin connector between icons */
.hero__rail-icons li:not(:last-child)::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 1px;
  height: 0; /* no gap line — icons already have padding */
  background: rgba(27, 27, 27, 0.25);
}

/* ---- Content ---- */
.hero__content {
  max-width: 50rem;
  /* push content down slightly from vertical center for visual balance */
  padding-bottom: 2rem;
}

.hero__title {
  color: var(--c-forest);
  font-size: var(--fs-hero);
  margin-bottom: clamp(1rem, 2vw, 1.75rem);
}

/* Clipping mask so each line slides up */
.hero__line {
  display: block;
  overflow: hidden;
}
.hero__line-inner {
  display: inline-block;
  will-change: transform;
}

.hero__sub {
  font-family: var(--font-body);
  font-size: var(--fs-lead);
  color: var(--c-ink);
  max-width: 30rem;
  margin-bottom: clamp(1.5rem, 2.5vw, 2.25rem);
}

/* ---- Email capture ---- */
.hero__form {
  display: flex;
  flex-wrap: wrap;
  gap: 0;
  max-width: 33rem;
  border: 1px solid var(--c-ink);
  border-radius: var(--radius-sm);
  background: rgba(244, 239, 230, 0.55);
  overflow: hidden;
}

.hero__input.form-control {
  flex: 1 1 12rem;
  border: 0;
  background: transparent;
  border-radius: 0;
  padding: 0.9rem 1.1rem;
  font-size: var(--fs-body);
  color: var(--c-ink);
}
.hero__input.form-control::placeholder {
  color: var(--text-muted);
}

.hero__cta.btn {
  flex: 0 0 auto;
  border: 0;
  border-radius: 0;
  background: var(--accent);
  color: var(--on-accent);
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  padding: 0.9rem 1.5rem;
  transition: background var(--dur) var(--ease);
}
.hero__cta.btn:hover,
.hero__cta.btn:focus-visible {
  background: var(--accent-hover);
}

/* ---- Watch the film ---- */
.hero__film {
  position: absolute;
  right: var(--gutter);
  bottom: clamp(1.75rem, 4vw, 3rem);
  display: inline-flex;
  align-items: center;
  gap: 0.85rem;
  background: none;
  border: 0;
  cursor: pointer;
  color: var(--c-cream);
}

.hero__film-play {
  display: grid;
  place-items: center;
  width: clamp(2.75rem, 4vw, 3.5rem);
  height: clamp(2.75rem, 4vw, 3.5rem);
  border: 1.5px solid currentColor;
  border-radius: 50%;
  font-size: 0.8rem;
  padding-left: 2px;
  transition:
    transform var(--dur) var(--ease),
    background var(--dur) var(--ease),
    color var(--dur) var(--ease);
}
.hero__film:hover .hero__film-play {
  transform: scale(1.08);
  background: var(--c-cream);
  color: var(--c-ink);
}

.hero__film-label {
  font-family: var(--font-body);
  font-weight: 600;
  font-size: 0.7rem;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

/* ---- Responsive ---- */
@media (max-width: 991.98px) {
  .hero__img {
    object-position: 32% center;
  }
  .hero__scrim {
    background:
      linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 32%, rgba(244, 239, 230, 0.82) 50%, rgba(244, 239, 230, 0.3) 72%, rgba(244, 239, 230, 0.05) 100%),
      linear-gradient(to top, rgba(27, 27, 27, 0.28) 0%, rgba(27, 27, 27, 0) 44%);
  }
}

@media (max-width: 767.98px) {
  .hero {
    height: 100dvh;
  }
  .hero__inner {
    grid-template-columns: 1fr;
    padding-inline: var(--gutter);
  }
  .hero__rail {
    display: none;
  }
  .hero__content {
    max-width: 100%;
    padding-bottom: 0;
  }
  .hero__film {
    position: absolute;
    bottom: 1.75rem;
    right: var(--gutter);
    color: var(--c-cream);
  }
}

.clouds {
  position: absolute;
  inset: 0;
  display: flex;
  width: 200%;
  height: 100%;
  opacity: 0.9;
  z-index: 1;
  pointer-events: none;
  mix-blend-mode: hard-light;

  animation: cloudMove 80s linear infinite;
}

.clouds img {
  width: 50%;
  height: 100%;
  object-fit: cover;
  flex-shrink: 0;
}

.cloud-flip {
  transform: scaleX(-1);
}

@keyframes cloudMove {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/Hero.css"],"names":[],"mappings":"AAAA;;;;;iEAKiE;;AAEjE;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA,uDAAuD;AACvD;EACE,kBAAkB;EAClB,QAAQ;EACR;;+EAE6E;AAC/E;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mEAAmE;EACnE,cAAc;EACd,aAAa;EACb,+BAA+B;EAC/B,mBAAmB,EAAE,yCAAyC;EAC9D,uCAAuC;EACvC,iBAAiB,EAAE,2BAA2B;EAC9C,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM,EAAE,2BAA2B;EACnC,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,4DAA4D;AAC5D;EACE,UAAU;EACV,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,kCAAkC;EAClC,kCAAkC;EAClC,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA,gEAAgE;AAChE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,UAAU;EACV,SAAS,EAAE,6CAA6C;EACxD,kCAAkC;AACpC;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,uEAAuE;EACvE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,gBAAgB;EAChB,8BAA8B;EAC9B,+BAA+B;EAC/B,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,6CAA6C;AAC/C;AACA;;EAEE,+BAA+B;AACjC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB;;;gCAG8B;AAChC;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE;IACE,2BAA2B;EAC7B;EACA;IACE;;iFAE6E;EAC/E;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,eAAe;IACf,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,0BAA0B;;EAE1B,wCAAwC;AAC1C;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ============================================================\n   Hero section\n   - Exactly 100dvh, no overflow\n   - Background image fades to cream on left\n   - Left index rail: small icons, long connector line\n   ============================================================ */\n\n.hero {\n  position: relative;\n  /* Exactly one viewport height — no overflow */\n  height: 100dvh;\n  background: var(--c-cream);\n  overflow: hidden;\n  isolation: isolate;\n}\n\n/* ---- Background media ---- */\n.hero__media {\n  position: absolute;\n  inset: 0;\n  mix-blend-mode: multiply;\n  z-index: -1;\n}\n\n.hero__img {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 0% center;\n}\n\n/* Cream scrim fades image → legible headline on left */\n.hero__scrim {\n  position: absolute;\n  inset: 0;\n  background:\n    linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 26%, rgba(244, 239, 230, 0.78) 40%, rgba(244, 239, 230, 0.18) 60%, rgba(244, 239, 230, 0) 76%),\n    linear-gradient(to top, rgba(27, 27, 27, 0.22) 0%, rgba(27, 27, 27, 0) 36%);\n}\n\n/* ---- Layout shell ---- */\n.hero__inner {\n  position: relative;\n  /* Fill exactly the viewport; navbar is fixed so no offset needed */\n  height: 100dvh;\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center; /* vertically center the rail + content */\n  column-gap: clamp(1rem, 2.5vw, 2.25rem);\n  padding-top: 64px; /* clear the fixed navbar */\n  z-index: 3;\n}\n\n/* ---- Index rail ---- */\n.hero__rail {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0; /* gaps managed per-child */\n  color: var(--c-ink);\n  height: 100%;\n  justify-content: center;\n}\n\n.hero__rail-num {\n  font-family: var(--font-body);\n  font-size: 1.5rem;\n  font-weight: 500;\n  letter-spacing: 0.1em;\n  margin-bottom: 0.9rem;\n}\n\n/* Long connector line — matches the screenshot proportion */\n.hero__rail-line {\n  width: 1px;\n  /* tall line, icons sit below it */\n  height: clamp(3.5rem, 10vw, 7rem);\n  background: rgba(27, 27, 27, 0.3);\n  margin-bottom: 0.9rem;\n}\n.hero__rail-line.alt {\n  width: 1px;\n  /* tall line, icons sit below it */\n  height: clamp(1.5rem, 2.5vw, 3rem);\n  background: rgba(27, 27, 27, 0.3);\n  margin-bottom: 0.3rem;\n  margin-top: 0.3em;\n}\n\n/* Icons — small, evenly spaced, separated by short tick lines */\n.hero__rail-icons {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n}\n\n.hero__rail-icons li {\n  display: grid;\n  place-items: center;\n\n  font-size: 2rem;\n  color: var(--c-ink);\n  opacity: 0.8;\n  padding: 0.65rem 0;\n  position: relative;\n}\n\n/* Thin connector between icons */\n.hero__rail-icons li:not(:last-child)::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 1px;\n  height: 0; /* no gap line — icons already have padding */\n  background: rgba(27, 27, 27, 0.25);\n}\n\n/* ---- Content ---- */\n.hero__content {\n  max-width: 50rem;\n  /* push content down slightly from vertical center for visual balance */\n  padding-bottom: 2rem;\n}\n\n.hero__title {\n  color: var(--c-forest);\n  font-size: var(--fs-hero);\n  margin-bottom: clamp(1rem, 2vw, 1.75rem);\n}\n\n/* Clipping mask so each line slides up */\n.hero__line {\n  display: block;\n  overflow: hidden;\n}\n.hero__line-inner {\n  display: inline-block;\n  will-change: transform;\n}\n\n.hero__sub {\n  font-family: var(--font-body);\n  font-size: var(--fs-lead);\n  color: var(--c-ink);\n  max-width: 30rem;\n  margin-bottom: clamp(1.5rem, 2.5vw, 2.25rem);\n}\n\n/* ---- Email capture ---- */\n.hero__form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0;\n  max-width: 33rem;\n  border: 1px solid var(--c-ink);\n  border-radius: var(--radius-sm);\n  background: rgba(244, 239, 230, 0.55);\n  overflow: hidden;\n}\n\n.hero__input.form-control {\n  flex: 1 1 12rem;\n  border: 0;\n  background: transparent;\n  border-radius: 0;\n  padding: 0.9rem 1.1rem;\n  font-size: var(--fs-body);\n  color: var(--c-ink);\n}\n.hero__input.form-control::placeholder {\n  color: var(--text-muted);\n}\n\n.hero__cta.btn {\n  flex: 0 0 auto;\n  border: 0;\n  border-radius: 0;\n  background: var(--accent);\n  color: var(--on-accent);\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 0.72rem;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  padding: 0.9rem 1.5rem;\n  transition: background var(--dur) var(--ease);\n}\n.hero__cta.btn:hover,\n.hero__cta.btn:focus-visible {\n  background: var(--accent-hover);\n}\n\n/* ---- Watch the film ---- */\n.hero__film {\n  position: absolute;\n  right: var(--gutter);\n  bottom: clamp(1.75rem, 4vw, 3rem);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.85rem;\n  background: none;\n  border: 0;\n  cursor: pointer;\n  color: var(--c-cream);\n}\n\n.hero__film-play {\n  display: grid;\n  place-items: center;\n  width: clamp(2.75rem, 4vw, 3.5rem);\n  height: clamp(2.75rem, 4vw, 3.5rem);\n  border: 1.5px solid currentColor;\n  border-radius: 50%;\n  font-size: 0.8rem;\n  padding-left: 2px;\n  transition:\n    transform var(--dur) var(--ease),\n    background var(--dur) var(--ease),\n    color var(--dur) var(--ease);\n}\n.hero__film:hover .hero__film-play {\n  transform: scale(1.08);\n  background: var(--c-cream);\n  color: var(--c-ink);\n}\n\n.hero__film-label {\n  font-family: var(--font-body);\n  font-weight: 600;\n  font-size: 0.7rem;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n}\n\n/* ---- Responsive ---- */\n@media (max-width: 991.98px) {\n  .hero__img {\n    object-position: 32% center;\n  }\n  .hero__scrim {\n    background:\n      linear-gradient(100deg, var(--c-cream) 0%, var(--c-cream) 32%, rgba(244, 239, 230, 0.82) 50%, rgba(244, 239, 230, 0.3) 72%, rgba(244, 239, 230, 0.05) 100%),\n      linear-gradient(to top, rgba(27, 27, 27, 0.28) 0%, rgba(27, 27, 27, 0) 44%);\n  }\n}\n\n@media (max-width: 767.98px) {\n  .hero {\n    height: 100dvh;\n  }\n  .hero__inner {\n    grid-template-columns: 1fr;\n    padding-inline: var(--gutter);\n  }\n  .hero__rail {\n    display: none;\n  }\n  .hero__content {\n    max-width: 100%;\n    padding-bottom: 0;\n  }\n  .hero__film {\n    position: absolute;\n    bottom: 1.75rem;\n    right: var(--gutter);\n    color: var(--c-cream);\n  }\n}\n\n.clouds {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  width: 200%;\n  height: 100%;\n  opacity: 0.9;\n  z-index: 1;\n  pointer-events: none;\n  mix-blend-mode: hard-light;\n\n  animation: cloudMove 80s linear infinite;\n}\n\n.clouds img {\n  width: 50%;\n  height: 100%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.cloud-flip {\n  transform: scaleX(-1);\n}\n\n@keyframes cloudMove {\n  from {\n    transform: translateX(0);\n  }\n  to {\n    transform: translateX(-50%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
